/**
 * General messages used on application.
 *
 * @type {String}
 */
export const ALREADY_SIGNED_HANDBOOK = 'You have already signed this handbook.';
export const CANCELED_REQUESTED_HANDBOOK = 'This e-signature request is no longer valid.';
export const CONTACT_SUPPORT = 'Please contact customer support for further questions.';
export const CONTACT_SUPPORT_DEFAULT = 'Please contact customer support for questions.';
export const UNABLE_REQUESTED_HANDBOOK = 'We are unable to retrieve the requested handbook at this time.';
export const UNABLE_REQUESTED_SIGNATURE = 'We are unable to retrieve this signature request.';
